export const APP_TITLE = 'Enlerno';